module.exports = __webpack_public_path__ + "img/upperBody.ad4bd923.svg";